import KunLoading79 from './src/index'

KunLoading79.install = function (Vue) {
	Vue.component(KunLoading79.name, KunLoading79);
}

export default KunLoading79;
